"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _prop2 = _interopRequireDefault(require("ramda/src/prop"));

var _isNil2 = _interopRequireDefault(require("ramda/src/isNil"));

var _ifElse2 = _interopRequireDefault(require("ramda/src/ifElse"));

var _map2 = _interopRequireDefault(require("ramda/src/map"));

var _isEmpty2 = _interopRequireDefault(require("ramda/src/isEmpty"));

var _reject2 = _interopRequireDefault(require("ramda/src/reject"));

var _split2 = _interopRequireDefault(require("ramda/src/split"));

var _fromPairs2 = _interopRequireDefault(require("ramda/src/fromPairs"));

var _pipe2 = _interopRequireDefault(require("ramda/src/pipe"));

var _test2 = _interopRequireDefault(require("ramda/src/test"));

var _when2 = _interopRequireDefault(require("ramda/src/when"));

var _curry2 = _interopRequireDefault(require("ramda/src/curry"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const lmlGet = (0, _curry2.default)((id, string) => (0, _when2.default)((0, _test2.default)(/^\d=/g), (0, _pipe2.default)((0, _split2.default)(/\n|\r/g), (0, _reject2.default)(_isEmpty2.default), (0, _map2.default)((0, _split2.default)('=')), _fromPairs2.default, (0, _ifElse2.default)((0, _pipe2.default)((0, _prop2.default)(id), _isNil2.default), (0, _prop2.default)(0), (0, _prop2.default)(id))))(string));
var _default = lmlGet;
exports.default = _default;